const VENDOR_DOMAINS = [
  /(?:[a-z0-9-]+\.)*southernsentinelsecurity\.com/gi,
  /(?:[a-z0-9-]+\.)*southernsentinelsecurity\.net/gi,
  /southernsentinelsecurity\.onmicrosoft\.com/gi,
];

const TENANT_DOMAIN = /\b[A-Z0-9-]+\.onmicrosoft\.com\b/gi;
const VENDOR_USERNAMES = /\b(credmaster|ProwlerReadOnly(?:-[A-Za-z0-9_-]*)?|Sentinel_Command|sentinel-command-portal)\b/gi;
const SECRET_PATH = /Secret\s+'sentinel-command\/production\/[^']+'/gi;
const PRODUCTION_SECRET_PATH = /\bsentinel-command\/production\/[^\s'",;)]+/gi;
const SHAREPOINT_VENDOR_ROOT = /SharePoint:Southern Sentinel Security\//gi;
const SHAREPOINT_CLIENT_ROOT = /SharePoint:Clients\/Documents\/Clients\/[^/\s]+/gi;
const UUID = /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi;
const HEX_HASH = /\b[a-f0-9]{32,64}\b/gi;
const EMAIL = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const EXT_MAILBOX = /\b[A-Z0-9._%+-]+#EXT#@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const AZURE_RESOURCE_ID = /\/subscriptions\/[0-9a-f-]{36}\/resourceGroups\/[^/\s]+\/providers\/[^\s,;)]+/gi;
const RUNNER_HOST = /\bsss-[a-z0-9-]+\b/gi;
const OPERATOR_NOTE = /Cancell?ed by operator during DAST (?:runner|scanner) validation batch reset on \d{4}-\d{2}-\d{2}\.?/gi;

export function isDemoRedactionEnabled(env = import.meta.env) {
  const value = String(env?.VITE_ENABLE_DEMO_POLISH || env?.VITE_ENABLE_DEMO_REDACTION || '').trim().toLowerCase();
  return value === 'true' || value === '1' || value === 'yes' || value === 'on';
}

export function redactDemoText(value, options = {}) {
  if (typeof value !== 'string' || value.length === 0) return value;
  const enabled = options.enabled ?? isDemoRedactionEnabled(options.env);
  if (!enabled) return value;

  let text = value;
  text = text.replace(SECRET_PATH, "Secret 'demo-client/integration-secret'");
  text = text.replace(PRODUCTION_SECRET_PATH, 'demo-client/integration-secret');
  text = text.replace(SHAREPOINT_VENDOR_ROOT, 'SharePoint:Demo Environment/');
  text = text.replace(SHAREPOINT_CLIENT_ROOT, 'SharePoint:Demo Environment/Documents');
  text = text.replace(AZURE_RESOURCE_ID, '/subscriptions/demo-subscription/resourceGroups/demo-resource-group/providers/demo-resource');
  text = text.replace(OPERATOR_NOTE, 'Canceled during scanner validation.');
  text = text.replace(EXT_MAILBOX, 'external.user@example.test');
  text = text.replace(EMAIL, email => email.toLowerCase().endsWith('@example.test') ? email : 'user@example.test');
  for (const domain of VENDOR_DOMAINS) {
    text = text.replace(domain, match => match.toLowerCase().includes('onmicrosoft') ? 'Demo Client Tenant' : 'client.example.test');
  }
  text = text.replace(TENANT_DOMAIN, 'Demo Client Tenant');
  text = text.replace(VENDOR_USERNAMES, 'demo-user');
  text = text.replace(/\bwireguard\b/gi, 'secure-connector');
  text = text.replace(RUNNER_HOST, 'managed-runner');
  text = text.replace(HEX_HASH, 'demo-tag');
  text = text.replace(UUID, 'demo-id');
  return text;
}

export function redactDemoObject(value, seenOrOptions = new WeakSet(), maybeOptions = {}) {
  const seen = seenOrOptions instanceof WeakSet ? seenOrOptions : new WeakSet();
  const options = seenOrOptions instanceof WeakSet ? maybeOptions : seenOrOptions;
  if (typeof value === 'string') return redactDemoText(value, options);
  if (!value || typeof value !== 'object') return value;
  if (seen.has(value)) return value;
  seen.add(value);
  if (Array.isArray(value)) return value.map(item => redactDemoObject(item, seen, options));
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, redactDemoObject(item, seen, options)]));
}
